import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Lock, ShieldCheckIcon, ZapIcon, ClockIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-96">
      {/* Background Glows - more intense */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-emerald-500/15 blur-[180px] rounded-full pointer-events-none" data-id="element-97" />
      <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] bg-amber-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-98" />

      {/* Decorative Elements */}
      <span className="absolute top-16 left-8 text-5xl opacity-[0.06] pointer-events-none select-none" data-id="element-99">
        🎯
      </span>
      <span className="absolute bottom-16 right-8 text-5xl opacity-[0.07] pointer-events-none select-none" data-id="element-100">
        🌿
      </span>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-102">
          {/* Animated outer glow ring */}
          <div className="absolute -inset-[2px] rounded-3xl bg-gradient-to-b from-emerald-400 via-emerald-500/50 to-amber-500/30 opacity-70 blur-[1px]" data-id="element-103" />
          <motion.div animate={{
          opacity: [0.4, 0.7, 0.4]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute -inset-[6px] rounded-3xl bg-gradient-to-b from-emerald-400/30 via-transparent to-amber-400/20 blur-md" data-id="element-104" />

          <div className="relative bg-gradient-to-b from-[#2f5c3d] to-[#1a3a25] rounded-3xl p-6 md:p-10 text-center overflow-hidden" data-id="element-105">
            {/* Inner ambient glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[200px] bg-emerald-400/10 blur-[100px] pointer-events-none" data-id="element-106" />
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[300px] h-[150px] bg-amber-500/8 blur-[80px] pointer-events-none" data-id="element-107" />

            {/* Urgency badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3,
            duration: 0.5
          }} className="relative z-10 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-500/15 border border-amber-400/30 text-amber-300 text-xs font-semibold tracking-wider uppercase mb-5" data-id="element-108">
              <motion.span animate={{
              scale: [1, 1.3, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity
            }} data-id="element-109">
                <ZapIcon className="w-3.5 h-3.5" data-id="element-110" />
              </motion.span>
              Oferta disponible ahora
            </motion.div>

            <h2 id="offer" className="relative z-10 text-2xl md:text-4xl font-bold text-white mb-3 scroll-mt-12 leading-tight" data-id="element-111">
              Recupera el mando de tu{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-300 to-teal-400" data-id="element-112">
                vitalidad
              </span>{' '}
              hoy mismo.
            </h2>

            <p className="relative z-10 text-base md:text-lg text-gray-300 mb-8 max-w-xl mx-auto leading-relaxed" data-id="element-113">
              El manual completo "Metabolismo en Punto de Equilibrio (40+)" está
              disponible por una fracción de lo que cuesta una consulta
              especializada o meses de suplementos innecesarios.
            </p>

            {/* Price block */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="relative z-10 mb-7" data-id="element-114">
              <p className="text-emerald-400 font-semibold uppercase tracking-widest mb-2 text-xs" data-id="element-115">
                Inversión única
              </p>

              <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-116">
                <p className="text-gray-500 text-lg line-through" data-id="element-117">$29.99</p>

                <div className="relative inline-block" data-id="element-118">
                  <div className="absolute inset-0 bg-amber-400/20 blur-[40px] rounded-full pointer-events-none" data-id="element-119" />
                  <span className="relative text-5xl md:text-7xl font-extrabold text-white tracking-tight" data-id="element-120">
                    $6.39
                  </span>
                  <span className="relative text-xl md:text-2xl text-gray-400 font-medium ml-1.5" data-id="element-121">
                    USD
                  </span>
                </div>

                <motion.div animate={{
                rotate: [-2, 2, -2]
              }} transition={{
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="px-2.5 py-1 rounded-full bg-red-500/20 border border-red-400/30 text-red-300 text-xs font-bold" data-id="element-122">
                  -79% OFF
                </motion.div>
              </div>
            </motion.div>

            {/* CTA */}
            <div className="relative z-10 flex flex-col items-center gap-4" data-id="element-123">
              <CTAButton href="https://pay.hotmart.com/A104892992N" className="w-full sm:w-auto" data-id="element-124" />

              {/* Trust signals */}
              <div className="flex flex-wrap justify-center gap-4 mt-1" data-id="element-125">
                <div className="flex items-center gap-1.5 text-xs text-gray-400" data-id="element-126">
                  <ZapIcon className="w-3.5 h-3.5 text-emerald-400" data-id="element-127" />
                  <span data-id="element-128">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-400" data-id="element-129">
                  <Lock className="w-3.5 h-3.5 text-emerald-400" data-id="element-130" />
                  <span data-id="element-131">Pago 100% seguro</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-400" data-id="element-132">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-emerald-400" data-id="element-133" />
                  <span data-id="element-134">Garantía de satisfacción</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}